import React from 'react';
import { Mail } from 'lucide-react';
import { useLanguage } from '../../i18n/LanguageContext.jsx';

const ForgotPasswordButton = ({ onClick, isLoading }) => {
  const { t } = useLanguage();
  return (
  <div className="mb-8">
    <button
      className="relative w-full group px-4 py-3 rounded-2xl bg-gradient-to-br from-white/95 to-white/80 backdrop-blur-sm shadow-[6px_6px_14px_rgba(0,0,0,0.05),-6px_-6px_14px_rgba(255,255,255,0.95)] hover:shadow-[8px_8px_18px_rgba(0,0,0,0.06),-8px_-8px_18px_rgba(255,255,255,1)] border border-white/60 transition-all duration-200 disabled:opacity-50"
      onClick={onClick}
      disabled={isLoading}
    >
      <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
      <span className="relative z-10 flex items-center justify-center gap-2 text-primary text-sm font-bold">
        <Mail className="w-4 h-4" />
        {t('login.forgotPassword')}
      </span>
    </button>
  </div>
  );
};

export default ForgotPasswordButton;
